import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useNavigate} from 'react-router-dom';
import {LOGIN} from 'routes';

interface AuthRedirectOptions {
  /** State object to pass to the login route */
  state?: any;
  /** Replace history entry when redirecting */
  replace?: boolean;
}

/**
 * Redirects to login when the provided error is an authentication error (401).
 * Usage: call with the error returned by a React Query or axios call.
 */
export default function useAuthRedirect(
  error: any,
  options?: AuthRedirectOptions
): void {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (error?.response?.status === 401) {
      navigate(
        LOGIN,
        {
          replace: options?.replace,
          state: {
            from: location,
            ...(options?.state || {}),
          },
        }
      );
    }
  }, [error, navigate, options?.replace, options?.state, location]);
}